import React, { Component } from 'react'
import Button from '@mui/material/Button'
import { Box } from '@mui/material'
import LoginRoundedIcon from '@mui/icons-material/LoginRounded'
import { withTranslation } from 'react-i18next'

import './LogoutPageStyles.css'

const session = require('../../config/session')

const REDIRECT_SECONDS = 10

class LogoutPage extends Component {

    constructor(props) {
        super(props)

        if (props.match && props.match.params.tag) {
            this.tagEntidad = props.match.params.tag
        }

        const fullName = localStorage.getItem('nombres') || ''
        this.userFirstName = fullName.trim().split(' ')[0] || ''

        session.endSession()

        this.state = {
            secondsLeft: REDIRECT_SECONDS,
            autoRedirect: true,
        }
    }

    componentDidMount() {
        session.endSession()
        this.timer = setInterval(this.tick, 1000)
    }

    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer)
    }

    tick = () => {
        if (!this.state.autoRedirect) return
        this.setState(prev => {
            const next = prev.secondsLeft - 1
            if (next <= 0) {
                this.goLogin()
                return { secondsLeft: 0 }
            }
            return { secondsLeft: next }
        })
    }

    cancelRedirect = () => {
        if (this.timer) clearInterval(this.timer)
        this.setState({ autoRedirect: false })
    }

    goLogin = () => {
        if (this.timer) clearInterval(this.timer)
        window.location.href = '/entidad/' + (this.tagEntidad || '')
    }

    render() {
        const { t } = this.props
        const { secondsLeft, autoRedirect } = this.state
        const año = new Date().getFullYear()
        const progress = ((REDIRECT_SECONDS - secondsLeft) / REDIRECT_SECONDS) * 100

        const heading = this.userFirstName
            ? `¡Hasta pronto, ${this.userFirstName}!`
            : t('window_logout_lbl_agradecimiento')

        return (
            <div
                className="logout-container"
                style={{ backgroundImage: 'url("/Pegasus0.png")' }}
            >
                <div className="logout-content">
                    <Box className="logout-card">
                        <div className="success-circle" aria-hidden="true">
                            <svg className="success-check" viewBox="0 0 52 52">
                                <circle cx="26" cy="26" r="24" fill="none" />
                                <path d="M14 27 l8 8 l16 -18" fill="none" />
                            </svg>
                        </div>

                        <div className="logout-text">
                            <h1>{heading}</h1>
                            <p>{t('window_logout_lbl_sesion_cerrada')}</p>
                        </div>

                        <div className="logout-brand">
                            <img alt="logo" src="/logo_main.png" />
                        </div>

                        {autoRedirect && (
                            <div className="logout-countdown" aria-live="polite">
                                <div className="logout-countdown-bar">
                                    <div
                                        className="logout-countdown-fill"
                                        style={{ width: `${progress}%` }}
                                    />
                                </div>
                                <span>Redirigiendo en {secondsLeft}s…</span>
                            </div>
                        )}

                        <div className="logout-actions">
                            <Button
                                onClick={this.goLogin}
                                startIcon={<LoginRoundedIcon />}
                                disableElevation
                                fullWidth
                                sx={{
                                    background:
                                        'linear-gradient(135deg, var(--clr) 0%, var(--clr-hover) 100%) !important',
                                    color: '#fff !important',
                                    textTransform: 'uppercase',
                                    fontWeight: 700,
                                    letterSpacing: '0.06em',
                                    fontSize: '0.95rem',
                                    py: '0.85rem',
                                    borderRadius: '14px',
                                    boxShadow: '0 8px 20px rgba(106, 158, 44, 0.35)',
                                    transition:
                                        'transform 200ms ease, box-shadow 200ms ease, filter 200ms ease',
                                    '&:hover': {
                                        filter: 'brightness(1.05)',
                                        transform: 'translateY(-1px)',
                                        boxShadow: '0 12px 24px rgba(106, 158, 44, 0.45)',
                                    },
                                }}
                            >
                                {t('window_logout_btn_login')}
                            </Button>

                            {autoRedirect && (
                                <button
                                    type="button"
                                    className="btn-logout-secondary"
                                    onClick={this.cancelRedirect}
                                >
                                    Cancelar redirección automática
                                </button>
                            )}
                        </div>
                    </Box>
                </div>

                <div className="logout-footer">
                    <span>© {año} Selfia. All rights reserved.</span>
                </div>
            </div>
        )
    }
}

export default withTranslation()(LogoutPage)
